import { useEffect } from 'react'

export function useHotjarTracking() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    ;(function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          ;(h.hj.q = h.hj.q || []).push(arguments)
        }
      h._hjSettings = { hjid: 3135927, hjsv: 6 }
      ;[a] = o.getElementsByTagName('head')
      r = o.createElement('script')
      r.async = true
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
      a.appendChild(r)
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')
  }, [])
}
